module.exports = __webpack_public_path__ + "static/media/p084.3471c10f.png";